import React from 'react';
import { LanguagePreferencesForm } from './Forms/LanguagePreferencesForm';

interface LanguageAndNotePreferencesFormProps {
  onSuccessfulFormSubmission: (subjectLanguage: string) => void;
}

const LanguageAndNotePreferencesForm = ({
  onSuccessfulFormSubmission,
}: LanguageAndNotePreferencesFormProps) => {
  return (
    <LanguagePreferencesForm
      title="Basic Settings"
      submitButtonText="Next"
      useRoundedButton={true}
      onSuccessfulFormSubmission={(subjectLanguage) => {
        // Always pass a string (defaults to 'patient' if undefined)
        onSuccessfulFormSubmission(subjectLanguage || 'patient');
      }}
    />
  );
};

export default LanguageAndNotePreferencesForm;
